<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<crucible-dialog
  dialogTitle="Edit Directory"
  [form]="form"
  submitLabel="Save"
  [submitDisabled]="!form.valid || !form.dirty"
  [guardUnsavedWork]="true"
  (cancel)="cancel()"
  (submit)="save()"
>
  <div crucibleDialogContent class="dialog-fields" [formGroup]="form">
    <mat-form-field>
      <input
        formControlName="name"
        matInput
        placeholder="Name"
        [value]="directory.name"
        cdkFocusInitial
      />
    </mat-form-field>

    <mat-form-field>
      <mat-label>Terraform Version</mat-label>
      <mat-select formControlName="terraformVersion">
        @for (version of sortedVersions; track version) {
          <mat-option [value]="version">
            {{ version
            }}{{ version === terraformVersions.defaultVersion ? ' (Default)' : '' }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Parallelism</mat-label>
      <input
        formControlName="parallelism"
        type="number"
        matInput
        [max]="maxParallelism"
        [min]="1"
        autocomplete="off"
      />
      <button
        mat-icon-button
        matIconSuffix
        type="button"
        class="pointer"
        aria-label="Parallelism help"
        matTooltip="Limit the number of concurrent Terraform operations. Value will be set on new Workspaces created in this Directory"
        matTooltipShowDelay="0"
        matTooltipHideDelay="0"
      >
        <mat-icon color="primary" fontIcon="mdi-information"></mat-icon>
      </button>
      @if (parallelism.invalid && (parallelism.dirty || parallelism.touched)) {
        <mat-error>
          @if (parallelism.hasError('min') || parallelism.hasError('max')) {
            Must be between 1 and {{ maxParallelism }}
          }
        </mat-error>
      }
    </mat-form-field>

    <div class="flex">
      <mat-form-field>
        <mat-label>Azure Threshold</mat-label>
        <input
          formControlName="azureDestroyFailureThreshold"
          type="number"
          matInput
          [max]="10"
          [min]="1"
          autocomplete="off"
        />
        <button
          mat-icon-button
          matIconSuffix
          type="button"
          class="pointer"
          aria-label="Azure threshold help"
          matTooltip="If set, the number of consecutive failed destroys in an Azure Workspace before Caster will attempt to mitigate by removing azurerm_resource_group children from the state."
          matTooltipShowDelay="0"
          matTooltipHideDelay="0"
        >
          <mat-icon color="primary" fontIcon="mdi-information"></mat-icon>
        </button>
        @if (
          azureDestroyFailureThreshold.invalid &&
          (azureDestroyFailureThreshold.dirty ||
            azureDestroyFailureThreshold.touched)
        ) {
          <mat-error>
            @if (
              azureDestroyFailureThreshold.hasError('min') ||
              azureDestroyFailureThreshold.hasError('max')
            ) {
              Must be between 1 and 10
            }
          </mat-error>
        }
      </mat-form-field>
      <mat-checkbox
        formControlName="azureDestroyFailureThresholdEnabled"
        (change)="toggleAzureThresholdEnabled($event)"
        matTooltip="Ignore Azure Threshold if disabled"
        >Enabled</mat-checkbox
      >
    </div>
  </div>
</crucible-dialog>
